/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirmdeletecontentreport3Inputs */

const en_confirmdeletecontentreport3 = /** @type {(inputs: Confirmdeletecontentreport3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this report?`)
};

const de_confirmdeletecontentreport3 = /** @type {(inputs: Confirmdeletecontentreport3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Meldung löschen?`)
};

/**
* | output |
* | --- |
* | "Delete this report?" |
*
* @param {Confirmdeletecontentreport3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const confirmdeletecontentreport3 = /** @type {((inputs?: Confirmdeletecontentreport3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirmdeletecontentreport3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confirmdeletecontentreport3(inputs)
	return de_confirmdeletecontentreport3(inputs)
});
export { confirmdeletecontentreport3 as "confirmDeleteContentReport" }